// src/components/Gallery.jsx
import { useState, useEffect } from "react";

export default function Gallery({ images }) {
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setSelectedIndex(null);
      if (e.key === "ArrowRight") goNext();
      if (e.key === "ArrowLeft") goPrev();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  });

  const goPrev = () => {
    if (images.length > 0 && selectedIndex !== null) {
      setSelectedIndex((prev) => (prev - 1 + images.length) % images.length);
    }
  };

  const goNext = () => {
    if (images.length > 0 && selectedIndex !== null) {
      setSelectedIndex((prev) => (prev + 1) % images.length);
    }
  };

  return (
    <div
      className="gallery grid gap-4"
      style={{ gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))" }}
    >
      {/* Thumbnails */}
      {images.map((img, index) => (
        <div
          key={index}
          className="flex flex-col items-center cursor-pointer"
          onClick={() => setSelectedIndex(index)}
        >
          <img
            src={img.url}
            alt={img.filename}
            className="block w-full aspect-[4/3] object-cover rounded shadow"
          />
          <div
            className="mt-1 text-xs text-center whitespace-normal break-all leading-snug w-full"
            style={{
              overflowWrap: "anywhere",
              color: "#aaa",       // ⬅ softened gray text for thumbnails
            }}
            title={img.filename}
          >
            {img.filename}
          </div>
        </div>
      ))}

      {/* Fullscreen Viewer */}
      {selectedIndex !== null && (
        <div className="image-viewer" onClick={() => setSelectedIndex(null)}>
          <div
            className="viewer-content"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              height: "100%",
            }}
          >
            {/* Large Image */}
            <img
              className="viewer-image"
              src={images[selectedIndex].url}
              alt={images[selectedIndex].filename}
              onClick={(e) => e.stopPropagation()}
              style={{
                maxWidth: "65%",
                maxHeight: "56vh",
                objectFit: "contain",
              }}
            />

            {/* Filename */}
            <div
              className="mt-3 text-center text-white break-words whitespace-normal"
              style={{
                maxWidth: "90%",
                fontSize: "1.25rem",
                fontWeight: "500",
              }}
            >
              {images[selectedIndex].filename}
            </div>

            {/* Close Button */}
            <button className="close-btn" onClick={() => setSelectedIndex(null)}>
              ✕
            </button>

            {/* Navigation Arrows */}
            <button
              className="nav-arrow left"
              onClick={(e) => {
                e.stopPropagation();
                goPrev();
              }}
            >
              ⬅
            </button>
            <button
              className="nav-arrow right"
              onClick={(e) => {
                e.stopPropagation();
                goNext();
              }}
            >
              ➡
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
